/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum GetTripModeDto {
  Air = 'air',
  Bicycle = 'bicycle',
  Bus = 'bus',
  CarFerry = 'carFerry',
  PassengerFerry = 'passengerFerry',
  Rail = 'rail',
  Express = 'express',
  Foot = 'foot',
  AirportBus = 'airportBus',
}
